import React, { useState, useEffect } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateIcon from "@material-ui/icons/Create";
import DeleteCategoryTaskModal from "@components/Modal/employees/CategoriesTasks/DeleteCategoryTask";
import { IconButton, Typography, Checkbox } from "@material-ui/core";

const BoardingCategoryTasksTable = ({
  categoryiesData,
  onEditTask,
  onUpdateComplete,
  onEditCategory,
  transitionType,
}) => {
  const [deletedTaskData, setDeletedTaskData] = useState({
    category_id: "",
    task_id: "",
  });
  const [tableHeaders, settableHeaders] = useState([]);
  const [deletedCategoryData, setDeletedCategoryData] = useState(null);
  const [isEmployeeTable, setIsEmployeeTable] = useState(false);

  useEffect(() => {
    if (transitionType === "onboarding") {
      settableHeaders(["Detail", "Responsible", "Status", "Action"]);
      setIsEmployeeTable(false);
    } else if (transitionType === "offboarding") {
      settableHeaders(["Detail", "Responsible", "Status", "Action"]);
      setIsEmployeeTable(false);
    } else {
      settableHeaders(["Detail", "Responsible", "Completed"]);
      setIsEmployeeTable(true);
    }
  }, []);
  return (
    <>
      <table
        style={{
          width: "90%",
          margin: "auto",
          backgroundColor: "white",
          marginBottom: "12px",
        }}
      >
        <thead
          style={{
            textAlign: "center",
            fontWeight: "bold",
            backgroundColor: "rgb(58 140 182)",
          }}
        >
          {tableHeaders.map((thead, index) => (
            <th
              key={index}
              style={{
                color: "white",
                padding: "6px 0px",
                fontSize: "20px",
                border: "1px solid black",
                textTransform: "capitalize",
              }}
            >
              {thead}
            </th>
          ))}
        </thead>
        <tbody>
          {categoryiesData?.length &&
            categoryiesData?.map((category, categoryIndex) => {
              return isEmployeeTable && !category.status ? (
                ""
              ) : (
                <>
                  <tr
                    key={categoryIndex}
                    style={{
                      textAlign: "center",
                      backgroundColor: "rgb(58 140 182/20%)",
                      fontSize: "18px",
                    }}
                  >
                    <td
                      colSpan={isEmployeeTable ? 4 : 1}
                      style={{
                        border: "1px solid black",
                        padding: "5px",
                        fontWeight: 600,
                      }}
                    >
                      {category.name}
                    </td>
                    {isEmployeeTable ? (
                      ""
                    ) : (
                      <>
                        <td style={cellStyle}>
                          <Typography variant="h7">---</Typography>
                        </td>
                        <td style={cellStyle}>
                          <Typography
                            variant="h7"
                            style={
                              category.status ? activeStyle : inactiveStyle
                            }
                          >
                            {category.status ? "Active" : "Inactive"}
                          </Typography>
                        </td>
                      </>
                    )}

                    {isEmployeeTable ? (
                      ""
                    ) : (
                      <td style={cellStyle}>
                        <IconButton
                          onClick={() => {
                            onEditCategory({
                              category_id: category._id,
                              category_name: category.name,
                              category_status: category.status,
                              category_type: transitionType,
                            });
                          }}
                        >
                          <CreateIcon />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            setDeletedCategoryData(category._id);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </td>
                    )}
                  </tr>
                  {category.task_id.map((task, taskIndex) => {
                    return isEmployeeTable && !task.status ? (
                      ""
                    ) : (
                      <tr
                        key={taskIndex}
                        style={{
                          textAlign: "center",
                          fontSize: "17px",
                        }}
                      >
                        <td style={cellStyle}>{task.name}</td>
                        <td style={cellStyle}>{task.comment}</td>
                        <td style={cellStyle}>
                          {isEmployeeTable ? (
                            <Checkbox
                              color="primary"
                              checked={task.is_completed}
                              onClick={() =>
                                onUpdateComplete(categoryIndex, taskIndex)
                              }
                            />
                          ) : (
                            <Typography
                              variant="body1"
                              style={
                                category.status
                                  ? task.status
                                    ? activeStyle
                                    : inactiveStyle
                                  : { color: "black" }
                              }
                            >
                              {category.status
                                ? task.status
                                  ? "Active"
                                  : "Inactive"
                                : "--"}
                            </Typography>
                          )}
                        </td>
                        {isEmployeeTable ? (
                          ""
                        ) : (
                          <td style={cellStyle}>
                            <IconButton
                              onClick={() => {
                                onEditTask({
                                  task_id: task._id,
                                  category_id: category._id,
                                  name: task.name,
                                  status: task.status,
                                  comment: task.comment,
                                });
                              }}
                            >
                              <CreateIcon />
                            </IconButton>
                            <IconButton
                              onClick={() => {
                                setDeletedTaskData({
                                  category_id: category._id,
                                  task_id: task._id,
                                });
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                </>
              );
            })}
        </tbody>
      </table>
      {deletedTaskData.category_id || deletedCategoryData ? (
        <DeleteCategoryTaskModal
          deletedTaskData={deletedTaskData}
          setDeletedTaskData={setDeletedTaskData}
          deletedCategoryData={deletedCategoryData}
          setDeletedCategoryData={setDeletedCategoryData}
          transitionType={transitionType}
        />
      ) : (
        " "
      )}
    </>
  );
};

export default BoardingCategoryTasksTable;

const inactiveStyle = {
  color: "red",
};
const activeStyle = {
  color: "green",
};
const cellStyle = {
  border: "1px solid black",
  textTransform: "capitalize",
};
